import createBehavior from '../create-behavior';
import $ from 'jquery';

export default () => {
    class Common {
        constructor($el, context, settings) {
            this.admin();
            this.envDbg(`
        Environment is: "${settings.env}".
      `);
            this.envDbg(`
        Example behavior on ${$el[0].nodeName} works! Its context is ${context.nodeName}.
      `);
        }

        admin() {
            $(document).ready(function () {
                let $checkbox = $('.media-library-view').find('.media-library-select-all');
                $('.media-library-views-form__header').append($checkbox);
            });
        }

        envDbg(message) {
            console.log(message);
        }
    }

    createBehavior('body', 'Common', Common);
}



// WEBPACK FOOTER //
// ./js/src/behaviors/common.js